import React, { useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Flame, AlertCircle } from "lucide-react";
import { useProductStats } from "../contexts/StatsContext";

const ProductCard = ({ product, index = 0 }) => {
  const [hovered, setHovered] = useState(false);
  const { stat } = useProductStats(product.slug);

  // Scarcity/social-proof badge derived from live stats
  let scarcityBadge = null;
  if (stat) {
    if (stat.sold_today >= 2) {
      scarcityBadge = {
        icon: Flame,
        text: `${stat.sold_today} bought today`,
        style: "bg-[#FF69B4] text-black",
      };
    } else if (stat.low_stock_qty !== null && stat.low_stock_qty !== undefined && stat.low_stock_qty > 0 && stat.low_stock_qty <= 4 && stat.low_stock_size) {
      scarcityBadge = {
        icon: AlertCircle,
        text: `Only ${stat.low_stock_qty} left in ${stat.low_stock_size}`,
        style: "bg-black/85 text-white ring-1 ring-[#FF69B4]/60",
      };
    } else if (stat.sold_week >= 3) {
      scarcityBadge = {
        icon: Flame,
        text: `${stat.sold_week} sold this week`,
        style: "bg-black/85 text-white ring-1 ring-white/20",
      };
    }
  }

  return (
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-50px" }}
      transition={{ duration: 0.7, delay: index * 0.06, ease: [0.22, 1, 0.36, 1] }}
      data-testid={`product-card-${product.slug}`}
    >
      <Link to={`/product/${product.slug}`} className="block group product-card">
        <div
          onMouseEnter={() => setHovered(true)}
          onMouseLeave={() => setHovered(false)}
          className="relative aspect-[3/4] bg-[#0e0e0e] overflow-hidden"
        >
          <img
            src={product.showBackFirst ? product.back : product.front}
            alt={`${product.name} main`}
            className={`absolute inset-0 w-full h-full object-cover transition-opacity duration-500 ${hovered ? "opacity-0" : "opacity-100"}`}
            loading="lazy"
          />
          <img
            src={product.showBackFirst ? product.front : product.back}
            alt={`${product.name} alternate`}
            className={`absolute inset-0 w-full h-full object-cover transition-opacity duration-500 ${hovered ? "opacity-100" : "opacity-0"}`}
            loading="lazy"
          />
          {product.bestSeller && (
            <span className="absolute top-3 left-3 bg-white text-black text-[9px] tracking-[0.2em] font-medium px-2 py-1">
              BEST SELLER
            </span>
          )}
          {scarcityBadge && (
            <span
              data-testid={`scarcity-${product.slug}`}
              className={`absolute bottom-3 left-3 flex items-center gap-1.5 px-2.5 py-1.5 text-[10px] tracking-[0.15em] uppercase font-semibold backdrop-blur ${scarcityBadge.style}`}
            >
              <scarcityBadge.icon size={11} />
              {scarcityBadge.text}
            </span>
          )}
        </div>
        <div className="pt-4 pb-2 flex items-start justify-between gap-2">
          <div>
            <p className="text-sm text-white/90 font-medium">{product.name}</p>
            <p className="text-xs text-white/40 mt-1">
              {product.category === "hoodies" ? "Hoodie" : "Tee"} · {product.color}
            </p>
          </div>
          <p className="text-sm">₹{product.price.toLocaleString("en-IN")}</p>
        </div>
      </Link>
    </motion.div>
  );
};

export default ProductCard;
